import { addDisplayName, flowMax } from 'ad-hok'
import { FC } from 'react'
import { EditInput } from 'shared/src/api/types'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { FormProps } from './resource'
import { NumberField, TextField } from './TextField'
import { Toggle } from './Toggle'
import { ImageField } from './ImageField'

export interface FormValues
  extends Omit<Partial<EditInput>, 'position' | 'isRodeoExclusive'> {
  position?: string
  isRodeoExclusive: boolean
}

export const EditForm: FC<FormProps<FormValues>> = flowMax(
  addDisplayName('EditsForm'),
  addTranslationHelpers,
  ({ values, onChange, errors, t }) => (
    <div>
      <TextField
        id="name"
        label={t('admin.resources.edits.fields.name')}
        value={values.name ?? ''}
        onChange={(name) => onChange({ ...values, name })}
        error={errors.name}
        focusOnMount
      />
      <NumberField
        id="position"
        label={t('admin.resources.edits.fields.position')}
        value={values.position}
        onChange={(position) => onChange({ ...values, position })}
        error={errors.position}
      />
      <Toggle
        id="isRodeoExclusive"
        label={t('admin.resources.edits.fields.isRodeoExclusive')}
        value={values.isRodeoExclusive}
        onChange={(isRodeoExclusive) =>
          onChange({ ...values, isRodeoExclusive })
        }
      />
      <ImageField
        id="backgroundImageId"
        label={t('admin.resources.edits.fields.coverImageId')}
        value={values.coverImageId}
        onChange={(coverImageId) => onChange({ ...values, coverImageId })}
        error={errors.coverImageId}
      />
    </div>
  )
)
